import { MigrationTargetStage } from "@amzn/fuse-accounting-central-datastore-client";

interface FacdClientConfig {
  readonly endpoint: string;
  readonly region: string;
}

const FACD_CLIENT_CONFIG_FROM_DOMAIN: Record<string, FacdClientConfig> = {
  "devo-FE": {
    endpoint:
      "https://beta-fe.execute-api.accounting-datastore.fuse.amazon.dev",
    region: "us-west-2",
  },
  "prod-EU": {
    endpoint:
      "https://prod-eu.execute-api.accounting-datastore.fuse.amazon.dev",
    region: "eu-west-1",
  },
  "prod-US": {
    endpoint:
      "https://prod-na.execute-api.accounting-datastore.fuse.amazon.dev",
    region: "us-east-1",
  },
  "prod-FE": {
    endpoint:
      "https://prod-fe.execute-api.accounting-datastore.fuse.amazon.dev",
    region: "us-west-2",
  },
};

export const getFacdConfig = (domain: string) => {
  const config = FACD_CLIENT_CONFIG_FROM_DOMAIN[domain];
  if (!config) {
    throw new Error(
      `No configuration found for FACD with config key: ${domain}`,
    );
  }

  return config;
};

export function toMigrationTargetStage(
  stage: string | undefined,
): MigrationTargetStage {
  const values = Object.values(MigrationTargetStage);
  if (stage && values.includes(stage as MigrationTargetStage)) {
    return stage as MigrationTargetStage;
  }
  // Default to "PROD" if invalid
  return MigrationTargetStage.PROD;
}
